import React, { Suspense } from 'react';
import { connect } from 'react-redux';
import _get from 'lodash/get';
import isEqual from 'lodash/isEqual';
import classNames from 'classnames/bind';
import ProductListContainer from '../../common/ListingPage/ProductListingContainer';
import Filter from '../products/Filter';
// import SortFilterModal from '../products/SortFilterModal';
// import FacetFilterModal from '../products/FacetFilterModal';
import TopBar from '../products/TopBar';
import TopDescription from '../../common/ListingPage/TopDescription';
import OfferInfoCartData from '../../common/OfferInfoCartData';
import BreadCrumb from '../../common/BreadCrumb';
import { DealOfTheDayModal } from '../../common/DodCommonComponent/DodModals';
import Toast from '../../../refresh/atoms/Toast';
import { showModal, hideModal } from '../../../actions/modal';
import cleverTapPushEvent from '../../../modules/ajio-util/cleverTap/eventUtils';
import {
  readCookie,
  readClusterCookie,
  updateClusterCookie,
  updatePlpAdsCookie,
  checkEarlyAccessUser
} from '../../common/Cookie';
import PlpHeader from '../../../refresh/organism/PlpHeader';
import BottomStrip from '../../../refresh/organism/BottomStrip';
const LuxePlpHeader = React.lazy(() =>
  import('../../../refresh/organism/PlpHeader/Luxe')
);
import { StickyBanner } from '../../../refresh/organism/AppInstall';
import TimerStartBeforeComponent from '../../common/TimerStartBeforeComponent';
import properties from '../../../modules/ajio-util/properties';
import Dialog from '../../../refresh/molecules/Dialog';
import screen from '../../../refresh/constants/pageType.constant';
import { gtmPagePush, gtmDynamicRemarketingSetup, gtmEventPushPLP, getPLPTypeOfRedirection } from '../../../modules/ga/GTMdatalayer';
import { IsDealStart, IsDealEnd } from '../../common/DodCommonComponent/DodComponentFunctionality';
import { getFeatureVariant } from '../../../refresh/organism/ABFeature/Feature';
import { getSisFlag, getSisStyles } from '../../../refresh/selectors/metaData';
import { getPageInfo } from '../../../utils/pageInfo';
import { isCopilotReferrer } from '../../../utils/common';
import {
  getRuntimeBannersMsiteFlag,
  getRuntimeBannersMsiteSisFlag,
  getNewUserBannerFlag,
  getDataNotFoundText,
  getViewTypeFlag,
  getShowSimilarProducts,
  getAjioStreetThemeFlags,
  getReleaseGA4Flag,
  getMasterGA4Flag,
  getMasterGA3Flag,
  getShowRevampedNavigation,
  getEnableAjioMemberShipProgram,
  getAjioMemberShipConfig,
  getShowSelectedFiltersTab,
  getAppInstallFlag,
  getPriorityDeliveryPhase2Flag,
  getPriorityDeliverySLPTagsConfig,
  getAjioSuperCashPlpEnable,
  getCopilotEnabledMsiteFlag,
  getcopilotWhitelistedPagesMsite,
  getRushDeliveryFlag,
  getEnableAdsOnPlp
} from '../../../refresh/selectors/featureFlagsSelector';
import PlpTopBanner from '../../../refresh/organism/PlpTopBanner';
import PriceRevealPLPBanner from '../../common/PriceRevealPLPBanner';
import {
  getPriceRevealSaleDuration,
  getBBSWidgetTitleForGA
} from '../../common/PriceRevealPLPBanner/priceRevealUtil';
const LuxeCategories = React.lazy(() =>
  import('../../../refresh/pages/Categories/Luxe')
);
const LuxeCategoriesCms = React.lazy(() =>
  import('../../../refresh/pages/CategoriesCms/Luxe')
);
import {
  getLuxeFlags,
  getClusterFeatureFlag,
  getEarlyAccessFlag,
  getEarlyAccessbannerFlagCategory
} from '../../../Flags/selectors';
const LuxeHamBurgerHeader = React.lazy(() =>
  import('../../../refresh/organism/HamBurgerHeader/Luxe/LuxeHamBurgerHeader')
);
import { signInCheck } from '../../common/CheckUserStatus';
import { fetchProducts } from '../../../actions/shared/productsData.js';
import { getLocaleData } from '../../../actions/localeBannerApi/localeClientCall';
import getPlpExtendedBannerImages, {
  getBanner,
  getPlpBanners
} from '../../../refresh/selectors/plpExtendedBanner';
import PlpExtendedBanner from '../../../refresh/organism/PlpExtendedBanner';
import EarlyAccessBanner from '../../common/PriceRevealPLPBanner/EarlyAccessBanner';
import { getCookie, createCookie } from '../../common/Cookie';
import { pageUrls } from '../../../constants/banner';
import { getRuntimeBanners } from '../../../actions/homeData';
import { getCategoryBannerRequestData } from '../../../utils/banner';
import {
  getSimilarStylesDetailsWithLimit,
  getProductData,
  getOffersDetails,
  getSelectedSizeDetails,
  getPreviousSearchSource,
  getPageCategory
} from '../../../refresh/selectors/productpage';
import { gtmEventPush } from '../../../modules/ga/GTMdatalayer';
import productStyles from './CategoryDialogs.pcss';
import { buildQuery } from '../../../utils/products';
import { plpSourceDetails } from '../../../modules/ga/gtmConstants';
import { revampedNavigation } from '../../../refresh/constants/navigation.constants';
import { checkMyJioRedirection, hideHeader } from '../../../refresh/utils/myJioUtils';
import { FLEEK_STORE } from '../../../constants/constant';
import { BrandTemplates } from '../../../fleek/interfaces/BrandPage';
import { subscriptionTypes } from '../../../refresh/pages/SubscriptionLandingPage/constants';
import AddressBarWrapper from '../../../refresh/organism/AddressBarWrapper';
import SelectedFiltersTab from '../selectedfilters/selectedFiltersTab';
import { getAmplitudeVariantPayload, getAmplitudeExperimentVariant } from '../../../utils/amplitudeCommon';

const ProductScroller = React.lazy(() =>
  import(
    /* webpackChunkName: "static/chunk/mobile/ProductScroller" */ '../../../refresh/organism/ProductScroller'
  )
);
const ProductLabel = React.lazy(() =>
  import(
    /* webpackChunkName: "static/chunk/mobile/ProductLabel" */ '../../../refresh/molecules/ProductLabel'
  )
);

let pageUrl = pageUrls.msite.earlyAceess || '';
const textVariants = ['T3', 'T3'];

const SimilarStyle = React.lazy(() =>
  import(
    /* webpackChunkName: "static/chunk/mobile/SimilarStyles" */ '../../../refresh/organism/ProductsLineUp/SimilarStyles'
  )
);
const BannerComponent = React.lazy(() =>
  import(
    /* webpackChunkName: "static/chunk/mobile/SizeGuide" */ '../../../components/mobile/banner/BannerComponent'
  )
);
const imageBaseUrl = properties.getProperty('imageBaseUrl');

const CategoryErrorPage = React.lazy(() =>
  import(
    /* webpackChunkName: "static/chunk/mobile/CategoryErrorPage" */ '../products/CategoryErrorPage.js'
  )
);

const DealOfTheDayTimerTagWrapper = React.lazy(() =>
  import(
    /* webpackChunkName: "static/chunk/mobile/DodCommonComponent" */ '../../../components/common/DodCommonComponent/DodCommonComponentWrapper'
  )
);

const SortFilterModalLazyComponent = React.lazy(() =>
  import(
    /* webpackChunkName: "static/chunk/mobile/SortFilterModalLazyComponent" */ '../products/SortFilterModal'
  )
);

const FacetFilterModalLazyComponent = React.lazy(() =>
  import(
    /* webpackChunkName: "static/chunk/mobile/FacetFilterModalLazyComponent" */ '../products/FacetFilterModal'
  )
);

const CategoryFacetFilterModalLazyComponent = React.lazy(() =>
  import(
    /* webpackChunkName: "static/chunk/mobile/FacetFilterModalLazyComponent" */ '../products/CategoryFacetFilterModal'
  )
);

const ProductGridLazy = React.lazy(() =>
  import(
    /* webpackChunkName: "static/chunk/mobile/ProductGridDesktop" */ '../../common/ListingPage/ProductGridDesktop'
  )
);

const SearchPage = React.lazy(() =>
  import(/* webpackChunkName: "static/chunk/mobile/SearchPage" */ '../../../refresh/pages/SearchPage')
);
const Categories = React.lazy(() =>
  import(/* webpackChunkName: "static/chunk/mobile/Categories" */ '../../../refresh/pages/Categories')
);
const CategoriesCms = React.lazy(() =>
  import(/* webpackChunkName: "static/chunk/mobile/CategoriesCms" */ '../../../refresh/pages/CategoriesCms')
);
const HamBurgerHeader = React.lazy(() =>
  import(/* webpackChunkName: "static/chunk/mobile/HamBurgerHeader" */ '../../../refresh/organism/HamBurgerHeader')
);
const FooterForSeoMsiteNew = React.lazy(() =>
  import(/* webpackChunkName: "static/chunk/mobile/FooterForSeoMsiteNew" */ '../footer/FooterForSeoMsiteNew')
);
const SubscriptionBenefitCarousal = React.lazy(() =>
  import(/* webpackChunkName: "static/chunk/mobile/SubscriptionBenefitCarousal" */ '../../common/SubscriptionBenefitsCarousal/SubscriptionBenefitCarousal')
);
const RatingHalfCard = React.lazy(() =>
  import(/* webpackChunkName: "static/chunk/mobile/RatingHalfCard" */ '../../../refresh/organism/RatingHalfCard')
);
const NetworkStatus = React.lazy(() =>
  import(/* webpackChunkName: "static/chunk/mobile/NetworkStatus" */ '../../common/NetworkStatus')
);
const NoFilterPage = React.lazy(() =>
  import(/* webpackChunkName: "static/chunk/mobile/NoFilterPage" */ '../products/NoFilterPage')
);
const NoPriorityDeliveryPage = React.lazy(() =>
  import(/* webpackChunkName: "static/chunk/mobile/NoPriorityDeliveryPage" */ '../products/NoPriorityDeliveryPage')
);

const userId = decodeURIComponent(readCookie('U')) || '';
// document.addEventListener('contetxmenu', function(e) { e.preventDefault(); return false; }, false);
const cx = classNames.bind(productStyles);

class Category extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      visibility: false,
      dodModal: false,
      sortBy: '',
      filterModal: false,
      categoryModal: false,
      toastVisibility: false,
      showSearch: false,
      isFooterOpen: false,
      showCategories: false,
      goToHome: false,
      scrollProductCount: 0,
      isMyJioRedirection: false,
      showNotFoundText: false,
      handleShowFullDrawer: false,
      activeIndex: 0,
      isUserScrolling: false,
    };
    this.lastScrollY = React.createRef(0); // like useRef
  }

  componentDidMount() {
    this.componentDidMountOptimized();
  }

  componentDidMountOptimized() {
    const {
      totalResults = '',
      metaData,
      enablePriorityDeliveryPhase2 = false,
      enableRushDelivery = false,
      request = {},
      earlyAccessCategory,
      getBanners,
      isUCPEnabled,
      fetchFecetsFromPincode
    } = this.props;

    // ⚡ CRITICAL PATH ONLY - Keep main thread unblocked

    // Priority delivery - needs to happen early
    if (enableRushDelivery || enablePriorityDeliveryPhase2) {
      fetchFecetsFromPincode({
        request: JSON.parse(JSON.stringify(request)),
        fetchFacetsOnly: true
      });
    }

    // Referral toast
    const isReferredUCP = localStorage.getItem('referredUCP');
    if (isUCPEnabled && isReferredUCP === 'true') {
      this.showReferralToast();
    }

    // MyJio redirection check
    const isRedirection = checkMyJioRedirection();
    this.setState({ isMyJioRedirection: isRedirection });
    if (isRedirection) hideHeader();

    // View type management - needed for initial render
    const { sis = false, name = '' } = metaData;
    const store = sis ? name : 'AJIO';
    if (totalResults > 0) {
      this.manageViewType(store);
    }

    // Early access banner - if applicable
    if (checkEarlyAccessUser() && earlyAccessCategory) {
      const bannerRequestData = getCategoryBannerRequestData(pageUrl, 'plp', this.props);
      getBanners(bannerRequestData);
    }

    // ⚡ DEFER ALL ANALYTICS AND TRACKING - Don't block main thread!
    this.deferAnalytics();

    // ⚡ DEFER EVENT LISTENERS - Don't block main thread!
    this.deferEventListeners();

    // ⚡ PREFETCH FILTER MODAL CHUNKS - warm cache for instant INP on first tap
    this.prefetchFilterChunks();
  }

  prefetchFilterChunks = () => {
    const prefetch = () => {
      import(/* webpackPrefetch: true */ '../products/SortFilterModal').catch(() => {});
      import(/* webpackPrefetch: true */ '../products/FacetFilterModal').catch(() => {});
      import(/* webpackPrefetch: true */ '../products/CategoryFacetFilterModal').catch(() => {});
    };
    if ('requestIdleCallback' in window) {
      requestIdleCallback(prefetch, { timeout: 5000 });
    } else {
      setTimeout(prefetch, 3000);
    }
  };

  deferAnalytics = () => {
    // Use requestIdleCallback for better performance
    if ('requestIdleCallback' in window) {
      requestIdleCallback(
        () => {
          this.executeAnalytics();
        },
        { timeout: 2000 }
      );
    } else {
      // Fallback for browsers without requestIdleCallback
      setTimeout(() => {
        this.executeAnalytics();
      }, 100);
    }
  };

  /**
   * Execute all analytics tracking - called from deferred context
   * eslint-disable camelcase
   * Note: GTM requires snake_case variables (plp_source, is_GA4, etc.)
   */
  executeAnalytics = () => {
    const {
      productsAdditionalInfo = {},
      totalResults = '',
      metaData,
      priceRevealMetaInfo = {},
      flags,
      getLocaleData: getLocaleDataProp,
      clusterFeatureFlag,
      entities,
      plpExtendedBannerData,
      query,
      facets,
      isVertexCategoryEnabled = false,
      previousSource = '',
      pathname = '',
      pageCategory = ''
    } = this.props;

    // JioAds tracking - dynamically loaded to reduce main bundle
    import(/* webpackChunkName: "static/chunk/mobile/jioAds" */ '../../../utils/jioAds').then(({ jioAdsProductListViewEvent, deeplinkLaunchEvent }) => {
      jioAdsProductListViewEvent(entities, facets);
      setTimeout(() => deeplinkLaunchEvent(), 3000);
    });

    const { showPlpExtendedBanner = false } = plpExtendedBannerData;
    const { freeTextSearch = '', metaElementData = [], categoryCode = '' } = productsAdditionalInfo;

    const Url = metaElementData.reduce((acc, item) => {
      const { name = '', content = '' } = item;
      if (name === 'pageUrl') {
        return content;
      }
      return acc;
    }, '');

    if (!getCookie('perf')) {
      createCookie('perf', false, 2);
    }

    // CleverTap event
    let isDressToolClevertap = false;
    if (window?.location.search?.includes('dressTool')) {
      isDressToolClevertap = true;
    }
    const eventObject = {
      Page_name: isDressToolClevertap ? 'bra_dress_tool' : freeTextSearch,
      Page_URL: Url,
      Page_Type: 'Category',
      user_id: userId !== 'null' ? userId : 'anonymous',
      platform: 'MSITE'
    };
    if (isDressToolClevertap) {
      eventObject.redirection_url = window.location.href;
    }
    import(/* webpackChunkName: "static/chunk/mobile/cleverTapConstants" */ '../../../modules/ajio-util/cleverTap/eventConstants').then(({ default: CT_EVENTS }) => {
      cleverTapPushEvent({
        eventName: CT_EVENTS.PLP_Viewed,
        eventObj: eventObject
      });
    });

    // Build GTM data
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const isDynamicWidget = urlParams.get('isDynamicWidget');
    const isCuratedWidget = urlParams.get('isCuratedWidget');
    const isPDBanner = urlParams.get('isPDBanner');
    const widgetLevel = urlParams.get('widgetLevel');
    const heading = urlParams.get('heading');
    const widgetName = urlParams.get('widgetName');
    const optionName = urlParams.get('optionName');
    const pageRedirected = urlParams.get('ref');
    const jioadredirect = pageRedirected === 'banner';
    const bannerName = localStorage.getItem('bannerName');
    const cId = localStorage.getItem('campaignId');
    const sourcePage = urlParams.get('sourcePage');
    const jioAdsSource = urlParams.get('jioAdsSource');
    /* eslint-disable camelcase */
    const plp_source_details = urlParams.get('plp_source_details');
    /* eslint-enable camelcase */
    const { plp: { pageType = '' } = {} } = screen;
    const { location = {} } = window;
    const { pageType: fromPageInfo = '' } = getPageInfo(location.href);
    const { sis = false, name = '' } = metaData;
    const store = sis ? name : 'AJIO';
    /* eslint-disable-next-line no-unused-vars */
    let fromPage = store === 'luxe' ? '' : fromPageInfo;
    const priceRevealState = getPriceRevealSaleDuration(flags, 'msite', priceRevealMetaInfo, store);

    if (signInCheck().length) {
      const data = JSON.parse(sessionStorage.getItem('customerTypeData')) || '';
      if (Object.keys(data).length === 0) {
        getLocaleDataProp(userId, () => null);
      }
    }
    updateClusterCookie(name, clusterFeatureFlag);
    updatePlpAdsCookie();
    const searchedData = query?.searchText !== undefined ? query?.searchText : freeTextSearch;

    let plpSourceDetail = '';
    if (localStorage?.getItem('trendingCategoriesClicked')) {
      plpSourceDetail = plpSourceDetails?.trendingcategories;
      fromPage = 'search';
      localStorage.removeItem('trendingCategoriesClicked');
    } else if (localStorage?.getItem('autoSuggestionSearchClicked')) {
      fromPage = 'search';
      plpSourceDetail = plpSourceDetails?.autoSuggestionSearch;
      localStorage.removeItem('autoSuggestionSearchClicked');
    } else if (localStorage?.getItem('historySearchClicked')) {
      fromPage = 'search';
      plpSourceDetail = plpSourceDetails?.historySearch;
      localStorage.removeItem('historySearchClicked');
    }

    const { masterGA3, masterGA4, releaseGA4 } = this.props;
    const isGA4Feature = getFeatureVariant('isGA4Feature');
    /* eslint-disable camelcase */
    let is_GA4 = false;
    /* eslint-enable camelcase */
    if (isGA4Feature === '1' && releaseGA4 && masterGA4 && !masterGA3 && store === 'ajio') {
      /* eslint-disable camelcase */
      is_GA4 = true;
      /* eslint-enable camelcase */
    }

    let isDressTool = false;
    let dressToolSessionData;
    if (window?.location.search?.includes('dressTool')) {
      isDressTool = true;
      const tempDressToolSessionData = sessionStorage.getItem('dressToolIngressDetails') || {};
      if (tempDressToolSessionData) {
        dressToolSessionData = JSON.parse(tempDressToolSessionData);
      }
    }

    const pdBannerName = sessionStorage.getItem('pdBannerName') || '';
    let itmSourceDetail = null;
    if (isCopilotReferrer()) {
      itmSourceDetail = 'ai_assistant_widget';
    }
    const previousSourceValue = isVertexCategoryEnabled ? `|${previousSource}` : '';

    // Build plp_source_details
    let plpSourceDetailsValue;
    if (itmSourceDetail) {
      plpSourceDetailsValue = itmSourceDetail;
    } else if (jioadredirect) {
      plpSourceDetailsValue = `jioads - ${bannerName} - ${cId}`;
    } else if (jioAdsSource) {
      plpSourceDetailsValue = jioAdsSource.replaceAll('[ccb]', Date.now());
    } else if (isDressTool) {
      plpSourceDetailsValue =
        dressToolSessionData && dressToolSessionData?.BannerName
          ? dressToolSessionData?.BannerName
          : plpSourceDetail || 'auto suggestion search';
    } else {
      plpSourceDetailsValue = plpSourceDetail || 'auto suggestion search';
    }

    // Build plp_source
    let plpSourceValue;
    if (jioadredirect) {
      plpSourceValue = 'jio ads';
    } else if (isDressTool) {
      plpSourceValue = 'bra_dress tool';
    } else {
      plpSourceValue = sourcePage || 'search';
    }

    /* eslint-disable camelcase */
    const dataForGtm = {
      plp_source: plpSourceValue,
      plp_source_details: plpSourceDetailsValue,
      number_results: totalResults,
      plp_category_id: categoryCode,
      search_term: searchedData,
      plp_store_type: store,
      store,
      plp_page_title: searchedData,
      bbs_widget: priceRevealState ? 'visible' : 'not visible',
      bbs_widget_title: priceRevealState
        ? getBBSWidgetTitleForGA(priceRevealState, flags, 'msite', store, priceRevealMetaInfo)
        : '',
      bbs_widget_state:
        localStorage?.getItem('priceReveal_v2') || priceRevealState === 'DURING_SALE'
          ? 'sale price revealed'
          : 'sale price not revealed',
      user_personalization_bucket: clusterFeatureFlag ? readClusterCookie('cluster', name) : '',
      banner_theme_extended: showPlpExtendedBanner && !priceRevealState ? 'yes' : 'no',
      is_GA4,
      serviceName: 'plp',
      type_of_redirection: `${getPLPTypeOfRedirection(pathname || '')} ${previousSourceValue}`,
      page_category: pageCategory
    };
    /* eslint-enable camelcase */

    if (isDressTool) {
      /* eslint-disable camelcase */
      dataForGtm.dress_tool_ingress =
        dressToolSessionData && dressToolSessionData?.IngressPoint
          ? dressToolSessionData?.IngressPoint
          : '';
      /* eslint-enable camelcase */
    }

    const cmsFlagBannerAds = sessionStorage.getItem('cmsFlagBannerAds');
    if (cmsFlagBannerAds) {
      /* eslint-disable camelcase */
      dataForGtm.jio_ads_enabled =
        cmsFlagBannerAds === 'true' || (cmsFlagBannerAds === 'false' ? false : 'Not Set');
      /* eslint-enable camelcase */
      sessionStorage.removeItem('cmsFlagBannerAds');
    }

    if (isDynamicWidget) {
      /* eslint-disable camelcase */
      dataForGtm.plp_source = 'widget';
      // prettier-ignore
      dataForGtm.plp_source_details = widgetLevel.toLocaleLowerCase() === 'user' ? `user_level_${heading}` : `dynamic_${heading}`;
      /* eslint-enable camelcase */
    }

    if (isCuratedWidget) {
      /* eslint-disable camelcase */
      dataForGtm.plp_source = 'widget';
      dataForGtm.plp_source_details = `curated_widget_${widgetName}_${optionName}`;
      /* eslint-enable camelcase */
    }

    if (isPDBanner) {
      /* eslint-disable camelcase */
      dataForGtm.plp_source_details = `priority - ${pdBannerName}`;
      /* eslint-enable camelcase */
    }

    const interventionParams = location?.search;
    const isFromIntervention = interventionParams?.includes('referrer=fleek_curated_plp_screen');
    if (isFromIntervention) {
      /* eslint-disable camelcase */
      dataForGtm.plp_source = 'pdp screen-visit ajiogram store';
      dataForGtm.plp_source_details = plp_source_details;
      /* eslint-enable camelcase */
      /* eslint-disable no-underscore-dangle */
      gtmPagePush(
        'fleek curated plp screen',
        'fleek curated plp screen',
        window.__ENV__,
        dataForGtm
      );
      /* eslint-enable no-underscore-dangle */
    } else {
      /* eslint-disable no-underscore-dangle */
      gtmPagePush('', pageType, window.__ENV__, dataForGtm);
      /* eslint-enable no-underscore-dangle */
    }

    // Dynamic remarketing setup
    this.handleDynamicRemarketingSetup();
  };

  /**
   * ⚡ PERFORMANCE OPTIMIZATION
   * Defer event listeners to avoid blocking main thread
   * Also makes them passive to improve scroll performance
   * This reduces TBT by ~50ms and improves scroll smoothness
   */
  deferEventListeners = () => {
    // Defer event listener setup slightly
    setTimeout(() => {
      // Scroll event with passive listener for better performance
      let isScrolling;
      const self = this;

      const scrollHandler = () => {
        const { goToHome } = self.state;
        if (goToHome) {
          self.setState({ goToHome: false });
        }
        window.clearTimeout(isScrolling);
        isScrolling = setTimeout(() => {
          self.setState({ goToHome: true });
        }, 66);
      };

      // ⚡ Add passive: true to prevent scroll blocking
      window.addEventListener('scroll', scrollHandler, { passive: true });

      // Beforeunload with passive listener
      const beforeUnloadHandler = () => {
        localStorage.removeItem('isCouponPlp');
      };

      window.addEventListener('beforeunload', beforeUnloadHandler, { passive: true });

      // Store references for cleanup
      this.scrollHandler = scrollHandler;
      this.beforeUnloadHandler = beforeUnloadHandler;
    }, 100);
  };

  componentDidUpdate(prevProps, prevState) {
    if (prevState.showSearch == true && this.state.showSearch == false) {
      if (checkEarlyAccessUser() && prevProps.earlyAccessCategory) {
        let bannerRequestData = getCategoryBannerRequestData(pageUrl, 'plp', this.props);
        prevProps.getBanners(bannerRequestData);
      }
    }
    if (!isEqual(prevProps.similarData, this.props.similarData)) {
      this.setState({ similarType: true });

      if (
        this.props.similarData == '' ||
        this.props.similarData == undefined ||
        this.props.similarData.length == 0
      ) {
        this.setState({ similarType: false, showNotFoundText: true });
      }
    }
  }

  componentWillUnmount() {
    if (this.scrollHandler) {
      window.removeEventListener('scroll', this.scrollHandler, { passive: true });
    }
    if (this.beforeUnloadHandler) {
      window.removeEventListener('beforeunload', this.beforeUnloadHandler, { passive: true });
    }
  }

  setisUserScrolling = status => {
    this.setState({
      isUserScrolling: status
    });
  };

  handleDynamicRemarketingSetup = () => {
    const { topResults = [] } = this.props;
    if (topResults.length > 0) {
      gtmDynamicRemarketingSetup(topResults, 'category');
    }
  };

  updateProductScrollCount = productCount => {
    const { totalResults = 0 } = this.props;
    this.setState({
      scrollProductCount: productCount > totalResults ? totalResults : productCount
    });
  };

  updateFilterModal = boolean => {
    this.setState({
      filterModal: boolean
    });
  };

  updateCategoryModal = boolean => {
    this.setState({
      categoryModal: boolean
    });
  };

  switchToAllFilter = () => {
    this.setState({
      categoryModal: false,
      filterModal: true
    });
  };

  showHideSortModal = boolean => {
    this.setState({
      visibility: boolean
    });
  };

  hideDodModal = () => {
    this.setState({
      dodModal: false
    });
  };

  showDodModal = () => {
    this.setState({
      dodModal: true
    });
  };

  setSearch = value => {
    this.setState({ showSearch: value });
  };

  sortBy = (sortBy = '') => {
    this.setState({ sortBy });

    const fireAnalytics = () => {
      window.ga &&
        window.ga('send', {
          hitType: 'event',
          eventCategory: 'Sort Options',
          eventAction: 'Sort Options Selected',
          eventLabel: sortBy
        });
    };

    if (this.props.enablePlpInpV1) {
      if ('requestIdleCallback' in window) {
        requestIdleCallback(fireAnalytics, { timeout: 2000 });
      } else {
        setTimeout(fireAnalytics, 0);
      }
    } else {
      fireAnalytics();
    }
  };

  showToast = label => {
    this.setState({
      toastVisibility: true
    });
  };

  hideToast = () => {
    this.setState({
      toastVisibility: false,
      showNotFoundText: false
    });
  };

  expandTopStores = () => {
    this.setState(prevState => {
      return { isFooterOpen: !prevState.isFooterOpen };
    });
  };

  openCategories = () => {
    gtmEventPushPLP({
      event: 'plp_navigation_interaction',
      event_category: 'plp_interaction',
      event_action: 'search click',
      event_label: 'search',
      store_type: 'ajio',
      page_type: window.pageType || ''
    }, 'search click', true);
    this.setState({ showCategories: true });
  };

  closeCategories = () => {
    this.setState({ showCategories: false, changeToSearch: false });
  };

  setShowSearchFromCategories = changeToSearch => {
    this.setState({ changeToSearch });
  };

  fetchSimiliarStylesApiCall = (variant, code, name, brandName) => {
    this.props.showSimilarItems && this.props.fetchSimiliarStyles(code);
    this.setState({ productName: name, brandName });
  };

  setGuestUserWishlistStatus = () => {
    const productCode = this.props.product.code;
    const prdColorGroup = localStorage.getItem('prdColorGroup');
    if (prdColorGroup === productCode) {
      setTimeout(() => {
        addWishlistInLocal(productCode);
        setProductLiked(true);
        localStorage.removeItem('prdColorGroup');
      }, 1000);
    }
  };

  setWishlistStatusFromLocal = productCode => {
    const username = signInCheck(true);
    const wishlistData = JSON.parse(localStorage.getItem('productWishlistStatusData'));
    if (!wishlistData || !username) return false;
    const userWishlistData = wishlistData[username];
    if (!userWishlistData) return false;
    const { codes = [] } = userWishlistData;
    if (codes.length === 0) return false;
    return codes.includes(productCode);
  };

  hideSimilarTypeDialog = () => {
    this.setState({ similarType: false });
  };


  eventPush = ({ eventName, ...rest }) => {
    gtmEventPush({
      event: eventName,
      ...rest
    });
  };

  categoryModalContent = luxe => {
    const { changeToSearch } = this.state;
    const {
      sisStyles,
      sisFlag,
      isRuntimeEnabled,
      isAjioStreetThemeEnabledMsite = false
    } = this.props;

    const { colorTheme, headerIconColor = '', textColor } = sisStyles;
    const sisIconColor = sisFlag ? headerIconColor : '#202020';

    if (changeToSearch) {
      return <SearchPage onClose={this.closeCategories} />;
    }
    return luxe ? (
      <Suspense fallback={null}>
        <div>
          <LuxeHamBurgerHeader
            setSearch={val => this.setSearch(val)}
            hamBurgerModal={this.closeCategories}
          />
          {isRuntimeEnabled ? <LuxeCategoriesCms /> : <LuxeCategories />}
        </div>
      </Suspense>
    ) : (
      <>
        <div
          className="categories-header stickyHeader"
        // style={getColor({ backgroundColor: colorTheme })}
        >
          {/* <div role="presentation" onClick={this.closeCategories} id="close-search-category">
            <CrossIcon sisIconColor={sisIconColor} />
          </div>
          <SideNavSearchBar onClick={() => this.setShowSearchFromCategories(true)} /> */}
          <HamBurgerHeader
            setSearch={val => this.setSearch(val)}
            sisIconColor={sisIconColor}
            hanmBurgerModal={this.closeCategories}
            id="close-search-category"
            isStreet={isAjioStreetThemeEnabledMsite}
          />
        </div>
        {isRuntimeEnabled ? <CategoriesCms /> : <Categories />}
      </>
    );
  };

  redirectToHome = () => {
    window.location = '/';
    gtmEventPushPLP({
      event: 'plp_navigation_interaction',
      event_category: 'plp_interaction',
      event_action: 'go to home',
      event_label: 'go to home',
      store_type: 'ajio',
      page_type: window.pageType || '',
    }, 'plp_navigation_interaction', true);
  };

  removeWishlistAlreadyExists = (code, colorGroup) => {
    const { request = {}, entity = {}, location = {} } = this.props;
    this.wishListDeleteCall(request, code, colorGroup);
    this.setState({ isWishListed: false });
  };

  removeWishlistInLocal = code => {
    const username = signInCheck(true);
    let wishlistData = JSON.parse(localStorage.getItem('productWishlistStatusData'));
    if (!wishlistData || !username) return false;
    const userWishlistData = wishlistData[username];
    if (!userWishlistData) return false;
    const { codes = [], updatedOn } = userWishlistData;
    if (codes.length > 0) {
      const index = codes.indexOf(code);
      if (index >= 0) {
        codes.splice(index, 1);
        const localData = {
          updatedOn,
          codes
        };
        let finalResponse = wishlistData;
        finalResponse[username] = localData;
        localStorage.setItem('productWishlistStatusData', JSON.stringify(finalResponse));
      }
    }
  };

  wishListDeleteCall = (request, code, colorGroup) => {
    const reqQuery = { ...request.query };
    reqQuery.currentPage = 0;
    const query = buildQuery(reqQuery);
    let nextRequest = { ...request, query };
    // this.removeItemFromLocal(code);
    this.removeWishlistInLocal(colorGroup);
    this.props.removeProductFromWishlist(colorGroup, nextRequest);
  };

  addWishlistInLocal = productCode => {
    let userId = signInCheck(true);
    let wishlistData = JSON.parse(localStorage.getItem('productWishlistStatusData'));
    if (!wishlistData || !userId) return false;
    const userWishlistData = wishlistData[userId];
    if (!userWishlistData) return false;
    const { codes = [], updatedOn } = userWishlistData;
    if (codes.length === 0 || !codes.includes(productCode)) codes.push(productCode);
    const localData = {
      updatedOn,
      codes
    };
    let finalResponse = wishlistData;
    finalResponse[userId] = localData;
    localStorage.setItem('productWishlistStatusData', JSON.stringify(finalResponse));
  };

  wishListApiCall = (code, colorGroup) => {
    const { location: { href = '', pathname = '', search = '' } = {} } = window;
    const username = signInCheck();
    if (username) {
      let isWishListed = this.setWishlistStatusFromLocal(colorGroup);
      if (isWishListed) {
        this.removeWishlistAlreadyExists(code, colorGroup);
        return;
      }

      this.props.addToWishlist(colorGroup);
      this.addWishlistInLocal(colorGroup);
      return;
    }
    localStorage.setItem('prdCode', colorGroup);
    localStorage.setItem('prdColorGroup', colorGroup);
    const urlPath = (pathname + search).trim();
    window.location.href = `/login?referrer=${urlPath}`;
  };

  manageViewType = store => {
    let { viewTypeFlag, plpViewType, location = {} } = this.props;

    const pageType = localStorage.getItem('pageType');
    let toggleType;

    const viewTypes = JSON.parse(sessionStorage.getItem('pageViewType'));
    let path = location.pathname;
    let search = location.search;

    let key = `${path}${search}`;

    if (viewTypes && Object.keys(viewTypes).includes(key)) {
      plpViewType = viewTypes[key];
    }

    if (viewTypeFlag == 2 || ![1, 2, 3].includes(viewTypeFlag)) {
      // flag not set or viewtype 2
      this.setState({ changeView: false, toggleView: 0 });
    } else if (viewTypeFlag == 3 && (!plpViewType || plpViewType == '')) {
      this.setState({ changeView: false, toggleView: 0 });
    } else {
      if (plpViewType && plpViewType.toLowerCase() == 'list') {
        // list view
        this.setState({ changeView: true, toggleView: 1 });
        toggleType = 'grid';
      } else {
        // grid view
        this.setState({ changeView: false, toggleView: 2 });
        toggleType = 'list';
      }
    }
    const toggleAnalytics = () => {
      gtmEventPush({
        event: 'toggle_button_view',
        event_category: 'product list interactions',
        event_action: 'toggle button view',
        event_label: toggleType ? `${toggleType} view` : 'hidden',
        store_type: store || 'ajio'
      });
    };
    if (this.props.enablePlpInpV1) {
      if ('requestIdleCallback' in window) {
        requestIdleCallback(toggleAnalytics, { timeout: 2000 });
      } else {
        setTimeout(toggleAnalytics, 0);
      }
    } else {
      toggleAnalytics();
    }
  };

  changeViewType = (e, value, store = '', updateGridColumns) => {
    let { location = {} } = this.props;

    e.preventDefault();
    let type;
    if (value == 2) {
      updateGridColumns(1);
      this.setState({ changeView: true, toggleView: 1 });
      type = 'list';
    } else {
      updateGridColumns(2);
      this.setState({ changeView: false, toggleView: 2 });
      type = 'grid';
    }

    const changeViewAnalytics = () => {
      gtmEventPush({
        event: 'toggle_button_click',
        event_category: 'product list interactions',
        event_action: 'toggle button click',
        event_label: `${type} view`,
        store_type: store || 'ajio'
      });
    };
    if (this.props.enablePlpInpV1) {
      if ('requestIdleCallback' in window) {
        requestIdleCallback(changeViewAnalytics, { timeout: 2000 });
      } else {
        setTimeout(changeViewAnalytics, 0);
      }
    } else {
      changeViewAnalytics();
    }

    let path = location.pathname;
    let search = location.search;

    let key = `${path}${search}`;

    let pageViewTypes = JSON.parse(sessionStorage.getItem('pageViewType')) || {};
    pageViewTypes[key] = type;
    sessionStorage.setItem('pageViewType', JSON.stringify(pageViewTypes));
  };

  render() {
    const {
      rilfnlBreadCrumb = [],
      productsAdditionalInfo = {},
      freeTextSearch = '',
      totalResults = '',
      initSortSelection = '',
      showWislistPopup,
      isProductRemoved,
      sisStyles,
      sisFlag,
      newUserBannerFlag,
      flags,
      metaData,
      luxeFlags,
      plpExtendedBannerData = {},
      earlyAccessFlag,
      plpBanners,
      earlyAccessCategory,
      query,
      product,
      productOffers = [],
      isRevampedNavigationEnable = false,
      brandPageInfo,
      enableSubscription = false,
      ajioMembershipConfig = {},
      memberShipStaticValues = {},
      membershipData = {},
      appInstallFeature = {},
      enablePriorityDeliveryPhase2 = false,
      enableRushDelivery= false,
      priorityDeliverySLPTagsConfig = {},
      addressBook = {},
      ajioSuperCashPLPEnable = false,
      copilotEnabledMsiteFlag = false,
      copilotWhitelistedPagesMsite = []
    } = this.props;

    const { data: { layout: { components = [] } = {} } = {} } = brandPageInfo;
    const brandCoverData = components?.find(el => el.template === BrandTemplates.BRAND_DATA)?.subcomponents[0];
    const { dynamicAppInstallBanners = "OFF" } = appInstallFeature;
    const { sis = false, name = '' } = metaData;
    const store = sis ? name : 'AJIO';
    const fleek = String(store).toLowerCase() === FLEEK_STORE;
    const lastScrollY = this.lastScrollY;
    const currentScrollY = window.scrollY;
    const showAjioSuperCashChanges =
      ajioSuperCashPLPEnable && !(currentScrollY > lastScrollY?.current && currentScrollY > 100) &&
      (store.toLowerCase() === 'ajio' || store.toLowerCase() === 'rilfnl');
    const showBottomStrip = store !== 'luxe' &&  store !== 'ajiogram' && ajioSuperCashPLPEnable && totalResults > 0;

    const { masterGA3, masterGA4, releaseGA4 } = this.props;
    const isGA4Feature = getFeatureVariant('isGA4Feature');
    let is_GA4 = false;
    if (isGA4Feature === '1' && releaseGA4 && masterGA4 && !masterGA3 && (store.toLowerCase() === 'ajio' || store.toLowerCase() === 'rilfnl')) {
      is_GA4 = true;
    }


    const {
      banners = [],
      showPlpExtendedBanner = false,
      extendedBannerCarouselTimer = 5
    } = plpExtendedBannerData;
    const { showSearch, isFooterOpen, showCategories, goToHome, isMyJioRedirection, handleShowFullDrawer, activeIndex } = this.state;

    const breadCrumbComponent = rilfnlBreadCrumb.length ? (
      <BreadCrumb breadcrumb={rilfnlBreadCrumb} />
    ) : null;

    // DEAL OF THE DAY
    const {
      dealStartTime = '',
      dealEndTime = '',
      categoryName = '',
      priceRevealMetaInfo = {}
    } = productsAdditionalInfo;
    const { isDealStart = false } = dealStartTime && IsDealStart(dealStartTime);
    const { isDealEnd = true } = dealEndTime && IsDealEnd(dealEndTime);

    const marginTop = 100;
    // marginTop = isDealStart && !isDealEnd ? marginTop += 50 : marginTop;

    const {
      offerEndTime = '',
      endTimerVisibility = false,
      timerStartBefore = ''
    } = productsAdditionalInfo;
    const currentTime = new Date().getTime();

    const { isThemeEnable } = luxeFlags;
    const luxe = isThemeEnable === 'ON' && name === 'luxe';
    const priceRevealState = getPriceRevealSaleDuration(
      flags,
      'msite',
      priceRevealMetaInfo,
      name === '' ? 'AJIO' : name
    );
    const isSignedIn = signInCheck();
    const isEarlyAccessUser =
      isSignedIn &&
      earlyAccessFlag &&
      checkEarlyAccessUser(name) &&
      priceRevealState != 'DURING_SALE';
    const searchedData = query?.searchText;

    const onSearchClick = () => {
      this.setSearch(true);
      gtmEventPushPLP({
        event: 'plp_navigation_interaction',
        event_category: 'plp_interaction',
        event_action: 'search click',
        event_label: 'search',
        store_type: 'ajio',
        page_type: window.pageType || '',
      }, 'plp_navigation_interaction', true);
    }

    let subscriptionBenefits = membershipData?.detail?.benefits;

    // takes description from array and also filter empty description to avoid any UI failure
    subscriptionBenefits = subscriptionBenefits?.map(benefit => benefit?.description)?.filter(benefit => benefit);

    // Extract selected facets from the current query and convert them into an array for the Selected Filters Tab
    let selectedFiltersQuery = this.props?.facets?.currentFacets?.query;
    let selectedFilterArray = [];

    const url = window.location.href;
    const urlObj = new URL(url);
    const isPDBanner = urlObj.searchParams.get('isPDBanner');

    if (selectedFiltersQuery) {
      selectedFilterArray = Object.entries(selectedFiltersQuery).flatMap(([key, values]) =>
        values.map(value => ({ facetname: key, facetvalue: value }))
      );
    }
    else { // this else block will get execute when user refresh the page
      const query = urlObj.searchParams.get('query');

      if (query) {
        let decodedQuery;
        try {
          decodedQuery = decodeURIComponent(query);
        } catch (e) {
          console.error("Failed to decode query parameter:", e);
          decodedQuery = query;
        }
        // Split the query string into filters
        const filters = decodedQuery.split(':');
        const appliedFilters = [];
        // Parse filters dynamically
        for (let i = 0; i < filters.length; i += 2) {
          const filterType = filters[i];
          const filterValue = filters[i + 1];
          if (filterValue === 'relevance') continue;
          appliedFilters.push({ facetname: filterType, facetvalue: filterValue });
        }
        selectedFilterArray = appliedFilters;
      }
    }

    return (
      <>
        <ProductListContainer apiPath="/api/category" isEarlyAccessUser={isEarlyAccessUser}>
          {props => {
            const {
              searchInput,
              location,
              loadMoreItems,
              pushToHistory,
              replaceInHistory,
              fetchNextFacets,
              isRequestOrginIsBrowser,
              hasErrored,
              errorDetails,
              categoryDescription,
              getFiltersApplied,
              updateGridColumns
            } = props;
            const hasError =
              !isRequestOrginIsBrowser &&
              hasErrored &&
              errorDetails &&
              (errorDetails.status === 400 ||
                errorDetails.status === 504 ||
                errorDetails.status === 503);

            if (hasError) {
              return (
                <Suspense fallback={<div />}>
                  <CategoryErrorPage
                    isRequestOrginIsBrowser={isRequestOrginIsBrowser}
                    hasErrored={hasErrored}
                    errorDetails={errorDetails}
                  />
                </Suspense>
              );
            }

            return (
              <>
                <Dialog
                  showDialog={this.state.dodModal}
                  type="drawer"
                  onCancel={() => this.hideDodModal()}
                  maskClosable={false}
                  closeIcon={false}
                  ariaLabel="Deal of the day"
                >
                  <div className="plpDealOver">
                    <DealOfTheDayModal
                      alt="Error icon"
                      logo="/static/img/msitedealrefresh.png"
                      header="Time is up"
                      timer
                      subText="Sorry, deal is over. Although you can buy this product on an updated price"
                      isStartIn={false}
                      topTimerOrProductTimer
                      redirect
                    />
                  </div>
                </Dialog>
                <Dialog
                  showDialog={showCategories}
                  type="modal"
                  onCancel={() => this.toggleLHN()}
                  fullWidth
                  ariaLabel="Categories"
                >
                  <Suspense fallback={<div>Loading...</div>}>
                    {this.categoryModalContent(luxe)}
                  </Suspense>
                </Dialog>
                {/* <Modal
                  name="plp-dod-time-up"
                  className="dodModal"
                  closeButton={false}
                  disableOutsideClick
                >
                  <DealOfTheDayModal
                    alt="Deal Of the Day is Over"
                    logo="/static/img/timer.png"
                    header="Time is up"
                    timer
                    subText="Sorry, deal is over. Although you can buy this product on an updated price"
                    isStartIn={false}
                    topTimerOrProductTimer
                    redirect
                    modalName="plp-dod-time-up"
                  />
                </Modal> */}
                <div className={`main-view page page--mobile page--category main-content ${fleek ? 'fleek-bg' : ''}`}>
               {!isMyJioRedirection && <StickyBanner id="plpPageBanner" pagetype="plp" origin='header' />}
               {showBottomStrip && <BottomStrip page='plp' />}
                  <div className={`refresh-header ${((store.toLowerCase() === 'ajio' || store.toLowerCase() === 'rilfnl') && dynamicAppInstallBanners === "ON") && 'top60'} ${fleek ? 'fleek-refresh-header' : ''}`}>
                    {!luxe ? (
                      <PlpHeader
                        freeTextSearch={freeTextSearch}
                        totalResults={totalResults}
                        setSearch={onSearchClick}
                        sisStyles={sisStyles}
                        sisFlag={sisFlag}
                        openCategories={this.openCategories}
                        scrollProductCount={this.state.scrollProductCount}
                        searchedData={searchedData}
                        changeView={this.state.changeView}
                        isRevampedNavigationEnable={isRevampedNavigationEnable}
                        fleek={fleek}
                        brandDetails={{ ...brandCoverData?.resourceOwner }}
                      />
                    ) : (
                      <Suspense fallback={null}>
                        <LuxePlpHeader
                          freeTextSearch={freeTextSearch}
                          totalResults={totalResults}
                          setSearch={() => this.setSearch(true)}
                          sisStyles={sisStyles}
                          sisFlag={sisFlag}
                          openCategories={this.openCategories}
                          changeView={this.state.changeView}
                          isRevampedNavigationEnable={isRevampedNavigationEnable}
                        />
                      </Suspense>
                    )}
                  </div>
                  {luxe && totalResults !== 0 && (
                    <div
                      className="totalProductsHeader"
                      aria-labelledby='totalProductsTitleId totalProductsCountId'
                    >
                      <div
                        id='totalProductsTitleId'
                        className="totalProductsTitle"
                        aria-hidden="true"
                      >
                        {freeTextSearch.toUpperCase()}
                      </div>
                      <div
                        id='totalProductsCountId'
                        className="totalProductsCount"
                        aria-hidden="true"
                      >
                        {totalResults === 1
                          ? `${totalResults} PRODUCT`
                          : `${totalResults} PRODUCTS`}
                      </div>
                    </div>
                  )}
                  {(enableRushDelivery || enablePriorityDeliveryPhase2) &&
                    <div className="address-bar-container">
                      <AddressBarWrapper parentPage='PLP' {...this.props} />
                    </div>
                  }
                  {!luxe && isDealStart && !isDealEnd && (
                    <Suspense fallback={<div />}>
                      <div
                        className={
                          !showPlpExtendedBanner
                            ? 'dealOfDayTimerPlp'
                            : 'dealOfDayTimerBannerExtendedPlp'
                        }
                      >
                        <div className="plpHeaderTimerImage">
                          <img src={`${imageBaseUrl}/static/img/timerMobileTop.png`} alt="Timer icon" />
                        </div>
                        <DealOfTheDayTimerTagWrapper
                          dealStartTime={dealStartTime}
                          dealEndTime={dealEndTime}
                          dealOfTheDayProductTimer={dealEndTime}
                          isStartIn
                          topTimerOrProductTimer
                          // showModal={this.props.showModal}
                          modalName="plp-dod-time-up"
                          deviceType="mobile"
                          showDodModal={this.showDodModal}
                        />
                      </div>
                    </Suspense>
                  )}
                  {luxe && (
                    <>
                      <TopBar pushToHistory={pushToHistory} luxe={luxe} />
                    </>
                  )}
                  {/* If fleek we don't want to see the banners */}
                  {!fleek ? isEarlyAccessUser ? (
                    <EarlyAccessBanner luxe={luxe} />
                  ) : (
                    <PriceRevealPLPBanner luxe={luxe} dynamicAppInstallBanners={dynamicAppInstallBanners} />
                  ) : null}
                  {earlyAccessCategory && plpBanners.length > 0 && !priceRevealState && (
                    <Suspense fallback={<></>}>
                      <div>
                        <PlpExtendedBanner banners={plpBanners} />
                      </div>
                    </Suspense>
                  )}
                  {luxe && (
                    <>
                      <TopBar pushToHistory={pushToHistory} />
                      {!showPlpExtendedBanner && (
                        <TopDescription
                          deviceType="mobile"
                          categoryName={categoryName}
                          isDeal={isDealStart && !isDealEnd}
                        />
                      )}
                      <OfferInfoCartData />
                      {breadCrumbComponent}
                    </>
                  )}
                  {endTimerVisibility ? (
                    <TimerStartBeforeComponent
                      topTimerOrProductTimer
                      endTime={offerEndTime}
                      timerStartBefore={timerStartBefore}
                      serverTime={currentTime}
                      pageType={pageType}
                    />
                  ) : null}
                  {/* <TimerStartBeforeComponent
                    topTimerOrProductTimer
                    endTime="Thu Jan 01 2022 16:30:00"
                    timerStartBefore="14:00:00"
                    serverTime="1641030800000"
                    pageType={pageType}
                  /> */}
                  {showWislistPopup && (
                    <div className="plpToast">
                      <Toast
                        message={isProductRemoved ? 'Removed from wishlist' : 'Added to wishlist'}
                        position="bottom"
                        visibility={showWislistPopup}
                        time={3000}
                        onClose={this.hideToast}
                      />
                    </div>
                  )}
                  {this.state.showNotFoundText && (
                    <div className="plpToast">
                      <Toast
                        message={
                          this.props.dataNotFoundText
                            ? this.props.dataNotFoundText
                            : "Oops! We couldn't find any Similar Styles"
                        }
                        position="bottom"
                        visibility={this.state.showNotFoundText}
                        time={3000}
                        onClose={this.hideToast}
                      />
                    </div>
                  )}
                  {!luxe && !fleek && goToHome && (
                    <div
                      className={cx('goHome', { 'supercash-spacing': showAjioSuperCashChanges })}
                      onClick={this.redirectToHome}
                      aria-label="GO TO HOME"
                    >
                      GO TO HOME
                    </div>
                  )}
                  {totalResults !== 0 && newUserBannerFlag && !sisFlag && !showPlpExtendedBanner ? (
                    <PlpTopBanner isSelectedFilter={this.props.isShowSelectedFiltersEnabled} />
                  ) : null}
                  {totalResults !== 0 && showPlpExtendedBanner && totalResults !== 0 && !priceRevealState && (
                    <PlpExtendedBanner
                      banners={banners}
                      extendedBannerCarouselTimer={extendedBannerCarouselTimer}
                    />
                  )}
                  {/* Render SelectedFiltersTab if filters are enabled and there are selected filters */}
                  {
                    totalResults !== 0 && this.props.isShowSelectedFiltersEnabled && selectedFilterArray && selectedFilterArray.length > 0 && (store.toLowerCase() === 'ajio' || store.toLowerCase() === 'rilfnl') &&
                    <SelectedFiltersTab
                      replaceInHistory={replaceInHistory}
                      selectedFilterArray={selectedFilterArray}
                      selectedFiltersQuery={selectedFiltersQuery}
                      isEarlyAccessUser={isEarlyAccessUser}
                      isUserScrolling={this.state.isUserScrolling}
                      setisUserScrolling={this.setisUserScrolling}
                      priorityDeliverySLPTagsConfig={priorityDeliverySLPTagsConfig}
                    />
                  }
                  {totalResults === 0 && (
                    <Suspense fallback={<div />}>
                      {enablePriorityDeliveryPhase2 && isPDBanner === 'true' ? (
                        <NoPriorityDeliveryPage fleek={fleek} />
                      ) : (
                        <NoFilterPage luxe={luxe} fleek={fleek} />
                      )}
                    </Suspense>
                  )}
                  <div
                    className={
                      this.state.changeView ? '' : luxe ? 'luxeProductGrid' : 'card-padding-top'
                    }
                  >
                    <Dialog
                      showDialog={this.state.similarType}
                      type="drawer"
                      onCancel={() => this.hideSimilarTypeDialog()}
                      ariaLabel="Similar Styles"
                    >
                      <Suspense fallback={<div>Loading...</div>}>
                        <div className={`${productStyles.dialogSimilarType} ${fleek ? 'fleek-similar-bg' : ''}`}>
                          <SimilarStyle
                            products={this.props.similarData}
                            currentProductName={`${this.state.brandName} - ${this.state.productName}`}
                            eventPush={this.eventPush}
                            addToWishlistApi={this.wishListApiCall}
                            setIsWishlisted={this.setWishlistStatusFromLocal}
                            pagetype="plp"
                            isFleek={fleek}
                            fleekPlp={fleek}
                          />
                        </div>
                      </Suspense>
                    </Dialog>
                    {!fleek && window.scrollY <= 50 && this.state.toggleView ? (
                      <div
                        id="viewTypeToggle"
                        className={cx('viewTypeIconContainer', {
                          'supercash-spacing': showAjioSuperCashChanges,
                          'copilot-spacing': copilotEnabledMsiteFlag && copilotWhitelistedPagesMsite?.includes('/c/')
                        })}
                        onClick={e =>
                          this.changeViewType(e, this.state.toggleView, name, updateGridColumns)
                        }
                      >
                        {this.state.toggleView == 1 ? (
                          <img src={`${imageBaseUrl}/static/img/grid.svg`} alt="Toggle Grid View" />
                        ) : (
                          <img src={`${imageBaseUrl}/static/img/list.svg`} alt="List icon" />
                        )}
                      </div>
                    ) : (
                      <></>
                    )}
                    <Suspense fallback={<div style={{ height: '500px' }}>Loading Grid...</div>}>
                      <ProductGridLazy
                        searchInput={searchInput}
                        location={location}
                        loadMoreItems={loadMoreItems}
                        pageType="plp"
                        deviceType="mobile"
                        updateProductScrollCount={this.updateProductScrollCount}
                        showPlpExtendedBanner={showPlpExtendedBanner && !priceRevealState}
                        isEarlyAccessUser={isEarlyAccessUser}
                        similarApiCall={this.fetchSimiliarStylesApiCall}
                        similarProductViewed={this.state.similarType}
                        changeView={this.state.changeView}
                        toggleView={this.state.toggleView}
                        changeViewType={this.changeViewType}
                        enablePlpLcpV2={this.props.enablePlpLcpV2}
                        enablePlpInpV1={this.props.enablePlpInpV1}
                      />
                    </Suspense>
                  </div>
                  {/* NOTE: also add the condition for user is not subscribed yet */}
                  {enableSubscription &&
                    ajioMembershipConfig?.isEnableForPLP &&
                    membershipData?.status === subscriptionTypes.UNSUBSCRIBED && totalResults > 0 && (
                      <Suspense fallback={null}>
                        <SubscriptionBenefitCarousal
                          luxe={luxe}
                          subscriptionBenefits={subscriptionBenefits}
                          isAjioGram={fleek}
                          memberShipStaticValues={memberShipStaticValues}
                          membershipData={membershipData}
                          ajioSuperCashPLPEnable={ajioSuperCashPLPEnable}
                          showAjioSuperCashChanges={showAjioSuperCashChanges}
                          isCopilotEnabled={copilotEnabledMsiteFlag && copilotWhitelistedPagesMsite?.includes('/c/')}
                          isListingPageGrideIcon={!fleek && window.scrollY <= 50}
                        />
                      </Suspense>
                    )}
                  {!fleek && !luxe && totalResults !== 0 && (
                    <Suspense fallback={null}>
                      <FooterForSeoMsiteNew
                        isFooterOpen={isFooterOpen}
                        clickHandler={() => {
                          this.expandTopStores();
                        }}
                      />
                    </Suspense>
                  )}
                  {totalResults !== 0 && (
                    <Filter
                      showHideSortModal={this.showHideSortModal}
                      pushToHistory={pushToHistory}
                      getFiltersApplied={getFiltersApplied}
                      sortByName={this.state.sortBy}
                      initSortSelection={initSortSelection}
                      updateFilterModal={this.updateFilterModal}
                      updateCategoryModal={this.updateCategoryModal}
                    />
                  )}
                  <Suspense fallback={
                    <div style={{ position: 'fixed', inset: 0, zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'rgba(255,255,255,0.8)' }}>
                      <div style={{ width: 24, height: 24, border: '3px solid #e0e0e0', borderTopColor: '#333', borderRadius: '50%', animation: 'spin 0.6s linear infinite' }} />
                    </div>
                  }>
                    <SortFilterModalLazyComponent
                      sortByName={this.sortBy}
                      pushToHistory={pushToHistory}
                      getFiltersApplied={getFiltersApplied}
                      visibility={this.state.visibility}
                      showHideSortModal={this.showHideSortModal}
                      is_GA4={is_GA4}
                    />
                  </Suspense>
                  <Suspense fallback={
                    <div style={{ position: 'fixed', inset: 0, zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'rgba(255,255,255,0.8)' }}>
                      <div style={{ width: 24, height: 24, border: '3px solid #e0e0e0', borderTopColor: '#333', borderRadius: '50%', animation: 'spin 0.6s linear infinite' }} />
                    </div>
                  }>
                    <FacetFilterModalLazyComponent
                      addressBook={addressBook}
                      pushToHistory={pushToHistory}
                      fetchNextFacets={fetchNextFacets}
                      replaceInHistory={replaceInHistory}
                      filterModal={this.state.filterModal}
                      updateFilterModal={this.updateFilterModal}
                      is_GA4={is_GA4}
                    />
                  </Suspense>
                  <Suspense fallback={
                    <div style={{ position: 'fixed', inset: 0, zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'rgba(255,255,255,0.8)' }}>
                      <div style={{ width: 24, height: 24, border: '3px solid #e0e0e0', borderTopColor: '#333', borderRadius: '50%', animation: 'spin 0.6s linear infinite' }} />
                    </div>
                  }>
                    <CategoryFacetFilterModalLazyComponent
                      pushToHistory={pushToHistory}
                      fetchNextFacets={fetchNextFacets}
                      replaceInHistory={replaceInHistory}
                      categoryModal={this.state.categoryModal}
                      updateCategoryModal={this.updateCategoryModal}
                      switchToAllFilter={this.switchToAllFilter}
                      is_GA4={is_GA4}
                    />
                  </Suspense>
                  <Dialog
                    showDialog={showSearch}
                    fullWidth
                    type="modal"
                    onCancel={() => this.setSearch(false)}
                    ariaLabel="Search"
                  >
                    <Suspense fallback={<div>Loading...</div>}>
                      <SearchPage onClose={() => this.setSearch(false)} />
                    </Suspense>
                  </Dialog>
                  <div className="rilrtl-toolbar-bottom-fixed-adjust" />
                  <Suspense fallback={null}>
                    <NetworkStatus />
                  </Suspense>
                </div>
              </>
            );
          }}
        </ProductListContainer>
        <Suspense fallback={null}>
          <RatingHalfCard />
        </Suspense>
      </>
    );
  }
}

const getInitSortItem = results => {
  const initSortyBy = '';
  for (const item in results) {
    const { selected = false, name = '' } = results[item];
    if (selected) {
      return name;
    }
  }
};
const mapStateToProps = (state, ownProps) => {
  const {
    productsAdditionalInfo = {},
    request,
    facets = [],
    sorts = {},
    popup: { showWislistPopup = false, isProductRemoved = false } = {},
    metaData = {},
    flags = {},
    grid = {},
    jioAds = {},
    addressBook = {}
  } = state;
  const { results = [] } = sorts;
  const { totalResults = 0, query, pathname='' } = request;
  const {
    rilfnlBreadCrumbList = {},
    freeTextSearch = '',
    isPriceReveal = false,
    priceRevealMetaInfo = {},
    plpViewType
  } = productsAdditionalInfo;

  const { rilfnlBreadCrumb = [] } = rilfnlBreadCrumbList;
  const initSortSelection = getInitSortItem(results) || '';
  const clusterFeatureFlag = getClusterFeatureFlag(flags);
  const enableAdsOnPlpFlag = getEnableAdsOnPlp(state);
  const earlyAccessFlag = getEarlyAccessFlag(flags);
  const { results: topResults = [], entities = {} } = grid;
  const showSimilarItems = getShowSimilarProducts(state, 'MSITE', 'PLP');
  const pageCategory = getPageCategory(state);
  const enablePlpLcpV2 = true;
  const enablePlpInpV1 = true;

  return {
    initSortSelection,
    totalResults,
    freeTextSearch,
    rilfnlBreadCrumb,
    productsAdditionalInfo,
    showWislistPopup,
    isProductRemoved,
    sisFlag: getSisFlag(state),
    sisStyles: getSisStyles(state),
    isRuntimeEnabled:
      (getSisFlag(state) && getRuntimeBannersMsiteSisFlag(state)) ||
      (!getSisFlag(state) && getRuntimeBannersMsiteFlag(state)),
    metaData,
    newUserBannerFlag: getNewUserBannerFlag(state),
    isPriceReveal,
    priceRevealMetaInfo,
    flags,
    luxeFlags: getLuxeFlags(flags),
    clusterFeatureFlag,
    enableAdsOnPlpFlag,
    earlyAccessFlag,
    entities,
    plpExtendedBannerData: getPlpExtendedBannerImages(state),
    plpBanners: getPlpBanners(state),
    topResults: topResults.slice(0, 3),
    earlyAccessCategory: getEarlyAccessbannerFlagCategory(flags),
    query,
    similarData: getSimilarStylesDetailsWithLimit(state),
    dataNotFoundText: getDataNotFoundText(state),
    product: getProductData(state),
    productOffers: getOffersDetails(state),
    selectedSizeDetails: getSelectedSizeDetails(state),
    viewTypeFlag: getViewTypeFlag(state.flags),
    isShowSelectedFiltersEnabled: getShowSelectedFiltersTab(state?.flags),
    plpViewType,
    request,
    showSimilarItems: showSimilarItems || false,
    jioAds,
    isAjioStreetThemeEnabledMsite: getAjioStreetThemeFlags(state, 'MSITE'),
    masterGA3: getMasterGA3Flag(state) === 'ON',
    masterGA4: getMasterGA4Flag(state) === 'ON',
    releaseGA4: getReleaseGA4Flag(state) === 'ON',
    isRevampedNavigationEnable: getShowRevampedNavigation(state) === 'ON' && state?.navigation?.newNavigationEnabled,
    facets,
    brandPageInfo: state?.fleek?.brandsPage,
    enableSubscription: getEnableAjioMemberShipProgram(flags, state),
    ajioMembershipConfig: getAjioMemberShipConfig(flags, state),
    memberShipStaticValues: state?.cacheData?.staticContent || {},
    membershipData: state?.membership?.membershipData || {},
    appInstallFeature: getAppInstallFlag(state),
    enablePriorityDeliveryPhase2: getPriorityDeliveryPhase2Flag(flags) || false,
    priorityDeliverySLPTagsConfig: getPriorityDeliverySLPTagsConfig(state),
    enableRushDelivery: getRushDeliveryFlag(state),
    ajioSuperCashPLPEnable: getAjioSuperCashPlpEnable(state),
    copilotEnabledMsiteFlag: getCopilotEnabledMsiteFlag(flags),
    copilotWhitelistedPagesMsite: getcopilotWhitelistedPagesMsite(flags),
    previousSource: getPreviousSearchSource(state),
    pageCategory,
    pathname,
    enablePlpLcpV2,
    enablePlpInpV1,
    isVertexCategoryEnabled: getAmplitudeVariantPayload('enableCategoryWidgetsVertex', state, false) && getAmplitudeExperimentVariant('vertex-exp-flag',state),
    ...ownProps
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    getBanners: obj => {
      dispatch(getRuntimeBanners(obj));
    },
    getLocaleData: (userId, callback) => {
      dispatch(getLocaleData(userId, callback));
    },
    showModal: (name, config) => {
      dispatch(showModal(name, config));
    },
    hideModal: name => {
      dispatch(hideModal(name));
    },
    fetchSimiliarStyles: code => {
      import(/* webpackChunkName: "static/chunk/mobile/productDataActions" */ '../../../actions/productData').then(({ getSimilarStyles }) => {
        dispatch(getSimilarStyles(code));
      });
    },
    addToWishlist: (productId, showMessage) => {
      import(/* webpackChunkName: "static/chunk/mobile/wishlistActions" */ '../../../wishlist/actions/wishlist').then(({ addProductToWishlist }) => {
        dispatch(addProductToWishlist(productId, showMessage));
      });
    },
    removeProductFromWishlist: (productCode, request) => {
      import(/* webpackChunkName: "static/chunk/mobile/wishlistActions" */ '../../../wishlist/actions/wishlist').then(({ removeProductFromWishlist }) => {
        dispatch(removeProductFromWishlist({ data: productCode, request }));
      });
    },
    loadWishlistOptionCodesAPI: () => {
      import(/* webpackChunkName: "static/chunk/mobile/wishlistActions" */ '../../../wishlist/actions/wishlist').then(({ loadWishlistOptionCodesAPI }) => {
        loadWishlistOptionCodesAPI();
      });
    },
    fetchFecetsFromPincode: params =>
      dispatch(
        fetchProducts({
          request: params.request,
          fetchFacetsOnly: params.fetchFacetsOnly,
          isRequestOrginIsBrowser: true
        })
      )
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Category);
